module.exports = __webpack_public_path__ + "img/pass-01.2922c2fc.svg";